<template>
  <div class="rating">
    <div class="title">
      {{ factory.companyName ?? '-' }}
      <div
        v-if="!factory.currentUserReport"
        @click="handleReport"
        class="report"
      >
        Report
      </div>
    </div>
    <div class="address">
      <div class="street">
        <Icon name="location-l" />
        {{ factory.location ?? '-' }},
      </div>
      <div class="country">
        <img
          class="img"
          src="https://cdn-image-old.bestdealer.com/cn.svg"
          alt=""
        >
        China
      </div>
      <div class="years">
        <div class="dot" />
        {{ factory.honestMerchant ?? '-' }} years
        <div class="dot" />
      </div>
    </div>
    <div class="employees">
      <div>{{ factory.employeesDesc ?? '-' }} employees</div>
      <div class="dot" />
      <div>{{ factory.plantAreaDesc ?? '-' }}</div>
    </div>
    <div
      class="star-wrapper"
      v-if="factory.supplierRatingVo"
    >
      <div class="count">
        <span>{{ factory.supplierRatingVo.compositeService.toFixed(1) }}</span>
        <span class="suffix">/5</span>
      </div>
      <div class="star">
        <StarRate
          :value="factory.supplierRatingVo.compositeService"
          type="black"
        />
      </div>
    </div>
    <div
      class="star-wrapper"
      v-else
    >
      -
    </div>
    <div class="other-count">
      <div
        class="other-count-item"
        v-for="(item, index) of ratings"
        :key="index"
      >
        <div class="text">
          {{ item.label }}
        </div>
        <div class="count">
          {{ item.score ? item.score.toFixed(1) : '-' }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import Icon from '../Icon/Icon.vue'
import { StarRate } from '@/components/StarRate'

const emits = defineEmits(['report'])

const props = defineProps({
  factory: {
    type: Object,
    required: true
  }
})

const handleReport = () => {
  emits('report')
  document.dispatchEvent(new Event('scroll', { bubbles: true }))
}

const ratings = computed(() => [
  { label: 'Trade Medal Level', score: props.factory.supplierRatingVo?.tradeMedalLevel },
  { label: 'Quality Experience', score: props.factory.supplierRatingVo?.qualityExperience },
  { label: 'Composite Service', score: props.factory.supplierRatingVo?.compositeService },
  { label: 'Dispute Complaint', score: props.factory.supplierRatingVo?.disputeComplaint }
])
</script>

<style lang='less' scoped>
.rating {
  width: 360px;
  padding: 16px;
  background: linear-gradient(#e0ebff, #ffffff);
  border-radius: 8px;
  .title {
    display: flex;
    justify-content: space-between;
    color: #232323;
    font-size: 12px;
    font-family: mon-600;
    line-height: 16px;
    .report {
      color: #5c5c5c;
      font-size: 10px;
      font-family: mon-500;
      text-decoration: underline;
      cursor: pointer;
      &:hover {
        color: var(--link-hover-color);
      }
    }
  }

  .address {
    display: flex;
    align-items: center;
    color: #5c5c5c;
    height: 16px;
    font-size: 10px;
    font-family: mon-500;
    margin-top: 5px;
    .street {

    }
    .country {
      display: flex;
      align-items: center;
      gap: 4px;
      color: #232323;
      margin-left: 6px;
      .img {
        width: 16px;
        height: 16px;
        object-fit: contain;
      }
    }
    .years {
      display: flex;
      align-items: center;
      gap: 4px;
      margin-left: 4px;
    }
  }

  .employees {
    display: flex;
    align-items: center;
    gap: 4px;
    color: #5c5c5c;
    font-size: 10px;
    font-family: mon-500;
    margin-top: 1px;
  }

  .star-wrapper {
    display: flex;
    gap: 8px;
    padding-bottom: 12px;
    border-bottom: 1px solid #ebf1f5;
    margin-bottom: 12px;
    .count {
      margin-top: 12px;
      color: #232323;
      font-size: 24px;
      font-family: mon-700;
      .suffix {
        font-size: 12px;
        font-family: mon-600;
        margin-left: 2px;
      }
    }
    .star {
      position: relative;
      top: 20px;
      height: 14px;
    }
  }

  .other-count {
    display: flex;
    flex-wrap: wrap;
    gap: 8px 32px;
    .other-count-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 148px;
      height: 16px;
      .text {
        color: #6e717a;
        font-size: 11px;
        font-family: mon-500;
      }
      .count {
        color: #232323;
        font-size: 12px;
        font-family: mon-600;
      }
    }
  }
}

.dot {
  width: 3px;
  height: 3px;
  border-radius: 50%;
  background-color: #969AA3;
}
</style>
